import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-764c894b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"inline-flex","align-items":"center"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "控制目标进程", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "process-tips" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "process-tips-header" }, "通配符使用规则:"),
  /*#__PURE__*/_createElementVNode("div", { class: "info-item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "info-header" }, "1.进程名、进程路径、数字签名支持使用："),
    /*#__PURE__*/_createElementVNode("div", { class: "info-row" }, [
      /*#__PURE__*/_createElementVNode("strong", null, "*："),
      /*#__PURE__*/_createTextVNode("匹配零个或多个字符")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "info-row" }, [
      /*#__PURE__*/_createElementVNode("strong", null, "?："),
      /*#__PURE__*/_createTextVNode("匹配任何单个字符")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "info-item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "info-header" }, "2.进程路径支持使用："),
    /*#__PURE__*/_createElementVNode("div", { class: "info-row" }, [
      /*#__PURE__*/_createElementVNode("strong", null, "*："),
      /*#__PURE__*/_createTextVNode("匹配零个或多个字符")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "info-row" }, [
      /*#__PURE__*/_createElementVNode("strong", null, "?："),
      /*#__PURE__*/_createTextVNode("匹配任何单个字符")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "info-row" }, [
      /*#__PURE__*/_createElementVNode("strong", null, "**："),
      /*#__PURE__*/_createTextVNode("递归匹配任意子目录。(例：dir/**/*.txt将匹配\"dir/subdir/file.txt\"、\"dir/subdir1/subdir2/file.txt\"等)")
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应用范围", -1))
const _hoisted_5 = { style: {"margin-top":"-2px"} }
const _hoisted_6 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_TaskTimeEdit = _resolveComponent("TaskTimeEdit")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_ProcessEdit = _resolveComponent("ProcessEdit")!
  const _component_PolicyBindScope = _resolveComponent("PolicyBindScope")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_ContentAdaptLayout, { class: "process-control-edit-wrap important" }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _ctx.cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          disabled: _ctx.isReadonly,
          class: "cm-ui-ml10",
          size: "small",
          type: "primary",
          onClick: _ctx.saveSetting
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "formNode",
        class: _normalizeClass(["main-form", { readonly: _ctx.isReadonly }]),
        rules: _ctx.formRules,
        model: _ctx.strategyData,
        "label-position": "left",
        "hide-required-asterisk": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "策略名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                size: "small",
                style: {"width":"240px"},
                placeholder: "请输入策略名称",
                modelValue: _ctx.strategyData.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.strategyData.name) = $event)),
                modelModifiers: { trim: true },
                disabled: !_ctx.strategyData.strategy.main_switch,
                maxlength: "50"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "label-line",
            label: "发现控制进程处理方式"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, {
                class: "sub-row",
                value: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 禁止启动运行 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "策略执行频率" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                size: "small",
                modelValue: _ctx.strategyData.strategy.frequency,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.strategyData.strategy.frequency) = $event)),
                disabled: !_ctx.strategyData.strategy.main_switch,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.strategyData.strategy.regular_tasks = [..._ctx.DEFAULT_SETTING.regular_tasks]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    type: 1,
                    label: "每天",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    type: 2,
                    label: "每周",
                    value: 2
                  }),
                  _createVNode(_component_el_option, {
                    type: 3,
                    label: "每月",
                    value: 3
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "策略执行时间" }, {
            default: _withCtx(() => [
              _createVNode(_component_TaskTimeEdit, {
                modelValue: _ctx.strategyData.strategy.regular_tasks,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.strategyData.strategy.regular_tasks) = $event)),
                "main-switch": _ctx.strategyData.strategy.main_switch,
                "mix-type": _ctx.strategyData.strategy.frequency,
                "default-end-min": 23 * 60 + 50
              }, null, 8, ["modelValue", "main-switch", "mix-type"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "process-edit-item",
            prop: "strategy.process_infos"
          }, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createTextVNode("  "),
                _createVNode(_component_el_tooltip, {
                  placement: "bottom-start",
                  effect: "light"
                }, {
                  content: _withCtx(() => [
                    _hoisted_3
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("i", null, [
                      _createVNode(_component_CmSvgIcon, {
                        name: "assets/icons/info-gray",
                        monochrome: "",
                        size: 18
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ProcessEdit, {
                modelValue: _ctx.strategyData.strategy.process_infos,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.strategyData.strategy.process_infos) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "label-line",
            prop: "strategy_group_ids"
          }, {
            label: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_PolicyBindScope, {
                  "bind-mode": _ctx.strategyData.bind_mode ?? 0,
                  "group-ids": _ctx.strategyData.strategy_group_ids || [],
                  "device-ids": _ctx.strategyData.device_ids || [],
                  "preset-group-id": _ctx.resolvedPolicyId ? undefined : _ctx.resolvedFromGroupId,
                  "permission-key": _ctx.PermissionFe.proc_control,
                  "strategy-over": _ctx.groupEditStrategyOverComputed,
                  disabled: !_ctx.strategyData.strategy.main_switch,
                  "onUpdate:bindMode": _cache[5] || (_cache[5] = ($event: any) => (_ctx.strategyData.bind_mode = $event)),
                  "onUpdate:groupIds": _cache[6] || (_cache[6] = ($event: any) => (_ctx.strategyData.strategy_group_ids = $event)),
                  "onUpdate:deviceIds": _cache[7] || (_cache[7] = ($event: any) => (_ctx.strategyData.device_ids = $event)),
                  onGroupUpdate: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formNode.validateField('strategy_group_ids')))
                }, null, 8, ["bind-mode", "group-ids", "device-ids", "preset-group-id", "permission-key", "strategy-over", "disabled"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model", "class"])
    ]),
    _: 1
  })), [
    [_directive_loading, _ctx.isLoading]
  ])
}